import { createMemoStyles } from '@wds/utils';
import { PricingAppTheme } from '~app/styles/pricing/types';
import { HIGHLIGHT } from '~pricing/components/Summary/useStyles';

import { MD_MEDIA_QUERY } from '~shared/media-query';
import { StyleProps, StyleRules } from './types';

function getGridTemplateAreas(packageCount: number): string {
  let str = '.';
  let i;
  for (i = 1; i <= packageCount; i += 1) {
    str += ` package${i}`;
  }
  return `"${str}"`;
}
function getTemplateArea(): object {
  return {
    gridTemplateAreas: ({ packageCount }: StyleProps) => getGridTemplateAreas(packageCount),
  };
}

export function getTemplate(): object {
  return {
    display: 'grid',
    gridTemplateColumns: ({ packageCount }: StyleProps) =>
      `minmax(10%, 380px) repeat(${packageCount}, minmax(10%, 280px))`,
    justifyContent: 'center',
  };
}

export default createMemoStyles<StyleRules, StyleProps, PricingAppTheme>(
  ({ elevation, spacing, pricingPalette, packageTheme }: PricingAppTheme) => ({
    Details: {
      padding: `0 ${spacing[6]}px`,
      margin: `${spacing[8]}px auto ${spacing[4]}px`,
      display: 'block',
      maxWidth: 350,
      [MD_MEDIA_QUERY]: {
        width: 'fit-content',
        maxWidth: 'unset',
      },
    },
    Sticky: {
      [MD_MEDIA_QUERY]: {
        backgroundColor: pricingPalette.colors.white,
        ...getTemplate(),
        ...getTemplateArea(),
        top: -1,
        position: 'sticky',
        boxShadow: `0 4px 2px -2px rgb(0 0 0 / 11%)`,
        zIndex: elevation.sky - 1,
      },
    },
    Highlighted: {
      ...HIGHLIGHT(pricingPalette.colors.flint, packageTheme),
    },
    Package1: {
      gridArea: 'package1',
    },
    Package2: {
      gridArea: 'package2',
    },
    Package3: {
      gridArea: 'package3',
    },
    Package4: {
      gridArea: 'package4',
    },
    Package5: {
      gridArea: 'package5',
    },
    Package6: {
      gridArea: 'package6',
    },
    Mobile: {
      display: 'block',
      [MD_MEDIA_QUERY]: {
        display: 'none',
      },
    },
    Desktop: {
      display: 'none',
      [MD_MEDIA_QUERY]: {
        display: 'block',
      },
    },
  })
);
